import React, { useEffect, useState } from "react";
import { isArabic } from "../utils/util";
import { getCountryData } from "../services/liferay/common";

export default function Country({
  label,
  setCountryLoading,
  onChangeHandler,
  optionDefault,
  country,
  setCountry,
  required,
  translationMap
}) {
  const [countries, setCountries] = useState([]);


  useEffect(() => {
    const fetchCountries = async () => {
      setCountryLoading(true);
      try {
        const response = await getCountryData();
        const data = await response.data;
        setCountries(data);
        setCountryLoading(false);
      } catch (error) {

      }
    };

    fetchCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="select_custom_box">

            <label htmlFor="dropdown">{translationMap?.nationality}</label>
            <div className="dropdown-form">
                <select
          id="dropdown"
          value={country}
          required={required}
          onChange={onChangeHandler}>
          
                    <option value="" disabled>
                        {optionDefault}
                    </option>
                    {countries.length > 0 &&
          countries.map((entry, index) =>
          <option key={index} value={entry.en_US}>
                                {isArabic() ? entry.ar_SA : entry.en_US}
                            </option>
          )}
                </select>
            </div>
        </div>);

}